import React from "react";
import theme from "../theme/theme1";
 
const WhyUs = () => {
  return (
    <div
      className="flex flex-col md:flex-row items-center py-16 overflow-hidden"
      style={{
        backgroundColor: theme.whyUsSection.backgroundColor,
        color: theme.whyUsSection.textColor,
        fontFamily: theme.whyUsSection.fontFamily,
      }}
    >
      {/* Left Side: Text Content */}
      <div className="flex flex-col justify-center md:w-1/2 px-6 md:px-12 text-center md:text-left space-y-4">
        {/* Heading */}
        <h1
          className="text-4xl md:text-5xl font-extrabold mb-2 animate-fadeIn text-center"
          style={{ color: theme.whyUsSection.headingTextColor }}
        >
          Why Velammal?
        </h1>

        {/* Subheading */}
        <p className="text-lg font-semibold animate-fadeIn delay-100 text-center">
          Experience, Excellence, and a Legacy of Success
        </p>

        {/* Description Text */}
        <p className="text-gray-700 text-lg leading-relaxed text-justify animate-fadeIn delay-200">
          Velammal has a strong foothold in the educational field, operating
          multiple institutions in Tamil Nadu for over{" "}
          <span className="font-semibold">37 years</span>. Equipped with{" "}
          <span className="font-semibold">Smart Classes</span>,{" "}
          <span className="font-semibold">ECALYP Classrooms</span>, and{" "}
          <span className="font-semibold">state-of-the-art laboratories</span>,
          Velammal ensures a rich learning experience for every child. With an
          unwavering commitment to excellence, we nurture students to become
          future-ready, equipping them with the knowledge and skills to navigate
          the complexities of the modern world.
        </p>

        {/* Button with reduced size */}
        <button
          className="mt-6 px-8 py-2 font-semibold rounded-full shadow-lg transition duration-300 ease-in-out transform hover:scale-105 animate-fadeIn delay-300 mx-auto block"
          style={{
            backgroundColor: theme.whyUsSection.buttonBackground,
            color: theme.whyUsSection.buttonText,
            boxShadow: theme.whyUsSection.buttonShadow,
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = theme.whyUsSection.buttonHoverBackground;
            e.currentTarget.style.color = theme.whyUsSection.buttonHoverText;
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = theme.whyUsSection.buttonBackground;
            e.currentTarget.style.color = theme.whyUsSection.buttonText;
          }}
        >
          Learn More &raquo;
        </button>
      </div>

      {/* Right Side: Image */}
      <div className="md:w-1/2 flex justify-center items-center mt-8 md:mt-0 animate-fadeIn delay-400">
        <img
          src="https://velammalnexus.com/wp-content/uploads/2023/11/pre-primary-1.jpg"
          alt="Velammal School"
          className="w-80 h-80 md:w-[34rem] md:h-[28rem] object-cover transition-transform duration-500 ease-in-out transform hover:scale-105"
          style={{ boxShadow: theme.whyUsSection.imageShadow }}
        />
      </div>
    </div>
  );
};

export default WhyUs;
